import { render, staticRenderFns } from "./AllowlistMintingActions.vue?vue&type=template&id=01d858e2&"
import script from "./AllowlistMintingActions.vue?vue&type=script&lang=js&"
export * from "./AllowlistMintingActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports